var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.003,
    viewBox: "0 0 40 40.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.373,2.016,24.588,5.8,34.755,15.969l3.785-3.785a5,5,0,0,0,0-7.078L35.459,2.016a5,5,0,0,0-7.078,0ZM22.82,7.569,4.589,25.808a6.936,6.936,0,0,0-1.736,2.925L.085,38.142A1.877,1.877,0,0,0,2.407,40.48l9.409-2.769a6.936,6.936,0,0,0,2.925-1.736L32.988,17.737Z",
    transform: "translate(-0.008 -0.55)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaPen);
export default __webpack_public_path__ + "static/media/faPen.517ddada12352af60dc5851786628a50.svg";
export { ForwardRef as ReactComponent };